import React, { useState } from "react";
import { AntIcon, Intro_Thumbnail } from "./icons";
import { useHistory } from "react-router-dom";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { useDisclosure } from "@chakra-ui/react";
import { Modal } from "antd";

function Judges({ data }) {
  const history = useHistory();
  const [selectedVideo, setSelectedVideo] = useState(null);
  const {
    isOpen: isVideoModal,
    onOpen: openVideoModal,
    onClose: closeVideoModal,
  } = useDisclosure();

  const handleIntroClick = (ev, url) => {
    ev.stopPropagation()
    setSelectedVideo(url);
    openVideoModal();
  };

  return (
    <div className="flex flex-col gap-3">
      <h1 className="text-xl font-gilroy-semibold">Judges</h1>

      {data?.length > 0 &&
        data?.map((judge) => (
          <div
            className="py-2 px-3 bg-[#f6f5fa] rounded-lg flex gap-4 items-center justify-between"
            key={judge?._id}
            onClick={() => {
              history.push(`/user/${judge?._id}`);
            }}>
            <div className=" flex items-center gap-4">
              <img
                src={judge?.profilePicture || AntIcon}
                alt="vector"
                className=" size-10 rounded-lg"
              />
              <h2 className="font-gilroy-medium">{`${judge?.firstName} ${judge?.lastName}`}</h2>
            </div>
            {judge?.judgeVideo && (
              <span onClick={(ev) => handleIntroClick(ev, judge?.judgeVideo)}>
                <PlayCircleIcon className="text-[#008080]" />
              </span>
            )}
          </div>
        ))}

      <Modal
        open={isVideoModal}
        onCancel={closeVideoModal}
        footer={null}
        centered
        width="auto"
        destroyOnClose={true}
        style={{ padding: 0 }}
        bodyStyle={{
          padding: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <video
          src={selectedVideo}
          controls
          autoPlay
          poster={Intro_Thumbnail}
          className="rounded-lg border border-gray-200 max-w-full h-auto"
          style={{ maxHeight: "80vh" }}
        />
      </Modal>
    </div>
  );
}

export default Judges;
